/**
 * ControlButton v0.2
 *
 * サブアクション（LOG / CONF）用の小型矩形ボタン。
 * v0.1 の position フロート方式は廃止し、親側のフレックス子要素として並ぶ前提。
 */

import styles from './ControlButton.module.css';

export interface ControlButtonProps {
  label: string;
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
}

export function ControlButton({ label, onClick, ariaLabel, disabled = false }: ControlButtonProps) {
  return (
    <button
      type="button"
      className={styles.root}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {label}
    </button>
  );
}
